import moment from 'jalali-moment';
import {useLocation, useNavigate} from 'react-router-dom';

import defaultImg from '../../../../assets/image/newShop/defaultImg.png';

const MyStoreCard = ({
  title,
  storeName,
  rate,
  discount_amount,
  image,
  created_at,
  advertisementGuid,
  status,
  advertisement_type,
}: IMyStoreCardProps) => {
  const today = new Date();
  const dateTime = moment(moment(new Date(created_at)))
    .locale('fa')
    .from(today);

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="flex w-full gap-2 p-2 rounded shadow-md ">
      <div className="rounded !h-[112px] !w-[112px] overflow-hidden">
        <img
          className="object-cover w-full h-full"
          alt=""
          src={image || defaultImg}
        />
      </div>
      <div className="flex flex-col justify-between flex-1">
        <div>
          <span className="font-Medium text-md">{title}</span>
          <div className="flex items-baseline justify-between mt-2">
            <div className="flex items-center gap-1 text-gray-700">
              <i className="icon-nameStore" />
              <span className="text-xs">{storeName}</span>
            </div>
            {!!rate && (
              <div className="flex items-center gap-1 px-2 rounded-full bg-gray-50">
                <i className="icon-nameStar text-warning-500" />
                <span className="text-xs">{rate}</span>
              </div>
            )}
          </div>
        </div>
        <div className="flex items-baseline justify-between w-full ">
          <span className="text-xs text-gray-700">
            {status === 'expired' ? 'منقضی شده' : dateTime}
          </span>
          <div className="flex gap-2">
            {!!discount_amount && (
              <div className="flex items-center justify-center w-6 h-5 p-2 text-white bg-red-500 rounded">
                <span className="text-[8px]"> %{discount_amount}</span>
              </div>
            )}
            <span
              className="font-Medium text-farm-shop-500 text-md"
              onClick={() => {
                navigate(`/my-ads/advertisment/${advertisementGuid}`, {
                  state: {
                    type: 'advertisement',
                    advertisement_type: advertisement_type,
                    from: location?.pathname,
                  },
                });
              }}
            >
              مدیریت آگهی
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyStoreCard;
